class e {
  constructor(t) {
    this.draggable = t;
  }
  attach() {
    throw new Error("Not Implemented");
  }
  detach() {
    throw new Error("Not Implemented");
  }
}
export {
  e as AbstractPlugin
};
